import { Box, CircularProgress, Typography } from "@mui/material"

export const RouteLoader = () => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100vh" width="100%" >
        <CircularProgress/>
        <Typography variant="body2" color="textSecondary" mt={2}>
            Loading Module...
        </Typography>
    </Box>
  );
};